import React, { useState } from 'react';
import { connect } from 'react-redux';
import Navigation from '../Components/Navigation/Navigation';
import MobileNavigation from '../Components/Navigation/MobileNavigation';
import useIsMobile from "../Hooks/useIsMobile"
import { closeMobileNavigation, openMobileNavigation } from '../Actions/Navigation.action';

const NavigationContainer = props => {
    const isMobile = useIsMobile("medium-large")

    const [activeMegaMenu, setActiveMegaMenu] = useState();
    const [megaMenuTimer, setMegaMenuTimer] = useState();

    const onLinkHover = link => {
        clearTimeout(megaMenuTimer);
        setMegaMenuTimer(setTimeout(() => {
            setActiveMegaMenu(link);
            setMegaMenuTimer(null);
        }, 100));
    }

    const onMouseLeaveLink = () => {
        clearTimeout(megaMenuTimer);
        setMegaMenuTimer(setTimeout(() => {
            setActiveMegaMenu(null);
            setMegaMenuTimer(null);
        }, 100));
    }

    return isMobile
        ? <MobileNavigation {...props} />
        : <Navigation {...props} onMouseLeaveLink={onMouseLeaveLink} onLinkHover={onLinkHover} onMegaMenuClose={() => setActiveMegaMenu(null)} activeMegaMenu={activeMegaMenu} />
}

const mapStateToProps = state => {
    return {
        ...state.navigation
    }
}

const mapDispatchToProps = dispatch => {
    return {
        closeMobile: () => dispatch(closeMobileNavigation()),
        openMobile: () => dispatch(openMobileNavigation())
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(NavigationContainer);